module.exports = __webpack_public_path__ + "static/media/chenxihuitongji2.671a01b7.png";